import { HrTeamPage } from "../hr/HrTeamPage";
import { NAV_COPY, NAV_ICONS } from "../../lib/navCopy";

export function ConsultancyTeamPage() {
  return (
    <HrTeamPage
      title={NAV_COPY.consultancy.admins}
      subtitle="People who can invite recruiters and manage this consultancy."
      icon={NAV_ICONS.consultancyAdmins}
    />
  );
}
